import { REVERSE_CANCEL_SUBSCRIPTION } from './actionTypes'

export default () => ({
  type: REVERSE_CANCEL_SUBSCRIPTION,
  payload: {

  }
})